/* Back-in-stock signup for the bundle configurators (Jacob, 2026-10-22).
 *
 * A set's sold-out colours and sizes used to be crossed out AND unclickable,
 * so a shopper who wanted one had no way to ask for it. They are clickable
 * now; picking one leaves Add to cart refusing with the "{piece} in {colour}
 * is sold out" line it already showed, and this brings in the same signup the
 * single PDPs have (snippets/jr-notify.liquid) under it.
 *
 * Klaviyo's Back in Stock API works per variant, and a set is several, so the
 * configurator hands over every sold-out piece of the set on screen and the
 * email is signed up for each of them. Same calls as jr-single-pdp.js, which
 * keeps its own copy for its one variant: the "Back In Stock Flow" in Klaviyo
 * sends the restock email, and the profile gets Language for its split.
 *
 * Loaded as a module before the configurator's own script, which calls
 * window.JRNotify.sync(el, variantIds) on every render. */
(function () {
  if (window.JRNotify) return;

  function post(el, path, body) {
    return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(el.dataset.company), {
      method: 'POST',
      headers: { 'Content-Type': 'application/vnd.api+json', 'revision': '2025-07-15' },
      body: JSON.stringify({ data: body })
    });
  }

  function say(el, text, ok) {
    var msg = el.querySelector('.jr-notify__msg');
    if (!msg) return;
    msg.textContent = text || '';
    msg.hidden = !text;
    msg.classList.toggle('is-ok', !!ok);
  }

  function bind(el) {
    if (el.dataset.jrBound) return;
    el.dataset.jrBound = '1';
    var form = el.querySelector('.jr-notify__form');
    if (!form) return;
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var input = form.querySelector('input[type="email"]');
      var btn = form.querySelector('button');
      var email = (input && input.value || '').trim();
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
        say(el, el.dataset.bad, false);
        if (input) input.focus();
        return;
      }
      var ids = (el.dataset.variants || '').split(',').filter(Boolean);
      if (!ids.length) return;
      if (btn) btn.disabled = true;
      say(el, '');
      Promise.all(ids.map(function (id) {
        return post(el, 'back-in-stock-subscriptions', {
          type: 'back-in-stock-subscription',
          attributes: {
            channels: ['EMAIL'],
            profile: { data: { type: 'profile', attributes: { email: email } } }
          },
          relationships: { variant: { data: { type: 'catalog-variant', id: '$shopify:::$default:::' + id } } }
        }).then(function (res) {
          if (!res.ok) throw new Error('klaviyo ' + res.status);
        });
      })).then(function () {
        /* Best effort, as on the single PDP: the signup already succeeded. */
        if (el.dataset.language) {
          post(el, 'profiles', { type: 'profile', attributes: {
            email: email,
            properties: { Language: el.dataset.language }
          } }).catch(function () {});
        }
        form.hidden = true;
        say(el, el.dataset.ok, true);
      }).catch(function () {
        say(el, el.dataset.err, false);
      }).then(function () {
        if (btn) btn.disabled = false;
      });
    });
  }

  /* Show the signup while the set on screen has a sold-out piece, for exactly
     those pieces. A different set of pieces is a new signup: the form comes
     back and the last message clears. */
  function sync(el, ids) {
    if (!el) return;
    bind(el);
    var seen = {};
    var list = (ids || []).map(String).filter(function (id) {
      if (!id || id === 'null' || id === 'undefined' || seen[id]) return false;
      seen[id] = true;
      return true;
    });
    var key = list.join(',');
    var changed = el.dataset.variants !== key;
    el.dataset.variants = key;
    el.hidden = !list.length;
    if (changed) {
      say(el, '');
      var form = el.querySelector('.jr-notify__form');
      if (form) form.hidden = false;
    }
  }

  window.JRNotify = { sync: sync };
})();
